/** Sample workflow item IDs */
var SampleWorkflowItemID;
(function (SampleWorkflowItemID) {
    SampleWorkflowItemID["SAMPLE_FILL_LEVEL"] = "sampleFillLevel";
    // TODO: Add more
})(SampleWorkflowItemID || (SampleWorkflowItemID = {}));
var SampleWorkflowContextID;
(function (SampleWorkflowContextID) {
    SampleWorkflowContextID["DEFAULT"] = "default";
})(SampleWorkflowContextID || (SampleWorkflowContextID = {}));
/** Procedure workflow item IDs */
var ProcedureWorkflowItemID;
(function (ProcedureWorkflowItemID) {
    ProcedureWorkflowItemID["LABEL_CONTAINERS"] = "labelContainers";
    ProcedureWorkflowItemID["DRAW_AND_CHART_TUBES"] = "drawAndChartTubes";
    ProcedureWorkflowItemID["PROCEDURE_CHARTING"] = "procedureCharting";
    ProcedureWorkflowItemID["CHARTING_FAILURE"] = "chartingFailure";
    ProcedureWorkflowItemID["SAMPLES"] = "samples";
    ProcedureWorkflowItemID["PROCEDURE_INSTRUCTIONS"] = "procedureInstructions";
    // TODO: Add more
})(ProcedureWorkflowItemID || (ProcedureWorkflowItemID = {}));
var PackingWorkflowItemID;
(function (PackingWorkflowItemID) {
    // Used for Offline Supply ProcedureBag/KitSupplyItem scanning after arriving
    PackingWorkflowItemID["SCAN_KIT_SUPPLY_ITEMS"] = "scanKitSupplyItems";
    PackingWorkflowItemID["PACK_SAMPLES"] = "packSampleSupplies";
    // TODO: Add more
})(PackingWorkflowItemID || (PackingWorkflowItemID = {}));
var DropOffWorkflowItemID;
(function (DropOffWorkflowItemID) {
    DropOffWorkflowItemID["SCAN_SPECIMEN_BAG"] = "scanSpecimenBag";
    DropOffWorkflowItemID["PRESENT_REQUISITION_FORM"] = "presentRequisitionForm";
})(DropOffWorkflowItemID || (DropOffWorkflowItemID = {}));
var ProcedureWorkflowContextID;
(function (ProcedureWorkflowContextID) {
    ProcedureWorkflowContextID["OFFLINE_SUPPLY_PACKING"] = "packOfflineSupplies";
    ProcedureWorkflowContextID["DROP_OFF_SAMPLES"] = "dropOffSamples";
    ProcedureWorkflowContextID["MAIL_IN_PACKING"] = "mailInPacking";
    ProcedureWorkflowContextID["DEFAULT"] = "default";
    ProcedureWorkflowContextID["DEFAULT_FAILURE"] = "default--failure";
})(ProcedureWorkflowContextID || (ProcedureWorkflowContextID = {}));
/** Waypoint action workflow item IDs */
var WaypointActionWorkflowContextID;
(function (WaypointActionWorkflowContextID) {
    WaypointActionWorkflowContextID["MAIL_IN_PACKING"] = "mailInPacking";
    WaypointActionWorkflowContextID["DEFAULT"] = "default";
})(WaypointActionWorkflowContextID || (WaypointActionWorkflowContextID = {}));
/** TODO: Consider adhering to a naming convention for child workflow pointers */
var WaypointActionWorkflowItemID;
(function (WaypointActionWorkflowItemID) {
    WaypointActionWorkflowItemID["PROCEDURES"] = "procedures";
    WaypointActionWorkflowItemID["MAIL_IN_PACKING"] = "mailInPacking";
    WaypointActionWorkflowItemID["PATIENT_DOB"] = "patientDOB";
    WaypointActionWorkflowItemID["FOLLOW_KIT_INSTRUCTIONS"] = "followKitInstructions";
    WaypointActionWorkflowItemID["UNLOCK_SUPPLIES"] = "unlockSupplies";
    WaypointActionWorkflowItemID["PATIENT_CONSENT"] = "patientConsent";
    WaypointActionWorkflowItemID["SCAN_MAIL_IN_BOX"] = "scanMailInBox";
    WaypointActionWorkflowItemID["PACKING_INSTRUCTIONS"] = "packingInstructions";
    WaypointActionWorkflowItemID["PACK_SPECIMEN_BAGS"] = "packSpecimenBags";
})(WaypointActionWorkflowItemID || (WaypointActionWorkflowItemID = {}));
/**
 * Waypoint workflow item IDs
 *
 * Number is used for unique ordering for workflow items
 * that are dependent on the same child's completion.
 * Numbers will be ignored for display purposes.
 */
var WaypointWorkflowItemID;
(function (WaypointWorkflowItemID) {
    WaypointWorkflowItemID["MAIL_IN_PACKING_NON_BLOCKING"] = "mailInPacking0";
    WaypointWorkflowItemID["MAIL_IN_PACKING_BLOCKING"] = "mailInPacking1";
    WaypointWorkflowItemID["DEPARTURE"] = "departure";
    WaypointWorkflowItemID["CONFIRM_DEPARTURE"] = "confirmDeparture";
    WaypointWorkflowItemID["ARRIVAL"] = "arrival";
    WaypointWorkflowItemID["ID_CARD"] = "idCard";
    WaypointWorkflowItemID["WAYPOINT_ACTIONS"] = "waypointActions";
})(WaypointWorkflowItemID || (WaypointWorkflowItemID = {}));

export { DropOffWorkflowItemID, PackingWorkflowItemID, ProcedureWorkflowContextID, ProcedureWorkflowItemID, SampleWorkflowContextID, SampleWorkflowItemID, WaypointActionWorkflowContextID, WaypointActionWorkflowItemID, WaypointWorkflowItemID };
